import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/incidencia-empleado-registro-alta-imss';

/**
 * GET Registros de Alta IMSS
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRegistrosAltaIMSS = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Registro de Alta IMSS por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRegistroAltaIMSS = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Registro de Alta IMSS
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRegistroAltaIMSS = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Registro de Alta IMSS
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRegistroAltaIMSS = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Registro de Alta IMSS
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRegistroAltaIMSS = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Registro de Alta IMSS
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarRegistroAltaIMSS = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
